import React, { useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { formatDateToddmmyyhhmm } from '../../../utils/dateformatter';

const ActivityTab = ({ activities = [], isLoading = false, onMount }) => {
  useEffect(() => {
    onMount?.();
  }, [onMount]);

  if (isLoading) {
    return (
      <div className='p-1 text-center py-5'>
        <Spinner color='primary' />
        <p className='text-muted small mt-2 mb-0'>Loading activity...</p>
      </div>
    );
  }

  if (!activities.length) {
    return (
      <div className='p-1'>
        <h5 className='fw-bold mb-1'>Activity</h5>
        <p className='text-muted fs-13 mb-3'>
          History of every awarding action on this procurement.
        </p>
        <div className='border rounded text-center py-5'>
          <i
            className='ri-history-line text-muted'
            style={{ fontSize: '3rem', opacity: 0.5 }}
          ></i>
          <p className='mt-2 mb-0 text-muted'>No activity recorded yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className='p-1'>
      <h5 className='fw-bold mb-1'>Activity</h5>
      <p className='text-muted fs-13 mb-3'>
        History of every awarding action on this procurement.
      </p>
      <ul className='list-unstyled mb-0'>
        {activities.map((activity, index) => (
          <li
            key={activity.id || index}
            className='d-flex gap-3 border-bottom py-3'
          >
            <span className='avatar-xs d-flex align-items-center justify-content-center bg-light rounded-circle'>
              <i className='ri-checkbox-circle-line text-primary'></i>
            </span>
            <div>
              <span className='d-block fw-medium text-dark'>
                {activity.description || activity.action}
              </span>
              <small className='text-muted'>
                {activity.action}
                {activity.activityDate
                  ? ` • ${formatDateToddmmyyhhmm(activity.activityDate)}`
                  : ''}
              </small>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ActivityTab;
